
import * as IDB from "idb";
import type { PlatformDBSchema, } from "./types";



export const getIDBVersion = (): number => {
	const { VITE_IDB_VERSION, } = import.meta.env;
	if(/^[0-9.]+$/.test(VITE_IDB_VERSION)) {
		return Number(VITE_IDB_VERSION);
	}
	throw new Error(`VITE_IDB_VERSION is not a number: ${VITE_IDB_VERSION}`);
}



const createStores = async ( db: IDB.IDBPDatabase<PlatformDBSchema>, slices: ("platform" | "vaults" | "bars_leaderboard" | "bars_points" | "wallet_points" | "swap")[], ) => {
	slices.forEach(db_name => {
		db.createObjectStore(db_name, { keyPath: "id", });
	});
}

const dropStores = async (db: IDB.IDBPDatabase<PlatformDBSchema>, slices: ("platform" | "vaults" | "bars_leaderboard" | "bars_points" | "wallet_points" | "swap")[], ) => {
	slices.forEach(db_name => {
		db.deleteObjectStore(db_name);
	});
}



let III: IDB.IDBPDatabase<PlatformDBSchema> | null = null;



export const getIDB = async (): Promise<IDB.IDBPDatabase<PlatformDBSchema>> => {
	if(III) {
		return III;
	}
	const version = getIDBVersion();
	const handler = await IDB.openDB<PlatformDBSchema>("bracket", version, {
		upgrade(db, oldVer, _, __) {
			if(oldVer < 1) {
				createStores(db, ["platform", "vaults", "bars_leaderboard", "bars_points", "wallet_points", "swap", ]);
			}
			else {
				dropStores(db, ["platform", "vaults", "bars_leaderboard", "bars_points", "wallet_points", "swap", ]);
				createStores(db, ["platform", "vaults", "bars_leaderboard", "bars_points", "wallet_points", "swap", ]);
			}
		},
		blocked(ver, blockedVer, evt) {
			console.log("blocked", ver, blockedVer, evt);
		},
		blocking(currentVersion, blockedVersion, event) {
			console.log("blocking", currentVersion, blockedVersion, event);
		},
		terminated() {
			console.log("terminated");
		}
	})
	III = handler;
	return III;
}
